import { ZIP_PATTERN, PHONE_PATTERN, NPI_PATTERN, BIN_PATTERN, isValidOrBlank, filled } from "./patterns";

export const isMedicalInsuranceSkipped = () => window.localStorage.getItem("medical-insurance-checked") == "yes";
export const isPharmacyInsuranceSkipped = () => window.localStorage.getItem("pharmacy-insurance-checked") == "yes";

export const hasInvalidPatientFormats = (enrollment_data) =>
    !isValidOrBlank(ZIP_PATTERN, enrollment_data?.address?.zip_code) ||
    (!isMedicalInsuranceSkipped() && !isValidOrBlank(BIN_PATTERN, enrollment_data?.insurance?.medical_insurance?.bin)) ||
    (!isPharmacyInsuranceSkipped() && !isValidOrBlank(BIN_PATTERN, enrollment_data?.insurance?.rx_insurance?.bin));

export const hasInvalidLapFormats = (enrollment_data) => !isValidOrBlank(ZIP_PATTERN, enrollment_data?.lap?.address?.zip_code);

export const providerFormatErrors = (provider_data) => {
    const errors = [];
    if (!isValidOrBlank(ZIP_PATTERN, provider_data?.address?.zip_code)) {
        errors.push("Provider Information: please enter a valid 5-digit ZIP code.");
    }
    if (!isValidOrBlank(PHONE_PATTERN, provider_data?.phones?.phone)) {
        errors.push("Provider Information: please enter a valid 10-digit phone number.");
    }
    if (!isValidOrBlank(NPI_PATTERN, provider_data?.npi)) {
        errors.push("Provider Information: NPI must be exactly 10 digits.");
    }
    return errors;
};

export const hasInvalidProviderFormats = (provider_data) => providerFormatErrors(provider_data).length > 0;

export const siteOfCareRequired = (site_of_care) => ({
    "Practice name": site_of_care?.name,
    Address: site_of_care?.address?.address1,
    City: site_of_care?.address?.city,
    State: site_of_care?.address?.state,
    "ZIP code": site_of_care?.address?.zip_code,
    "Phone number": site_of_care?.phone_number,
});

export const isSiteOfCareStarted = (site_of_care) =>
    Object.values(siteOfCareRequired(site_of_care)).some(filled) ||
    filled(site_of_care?.address?.address2) ||
    filled(site_of_care?.npi);

export const hasSiteOfCareIncomplete = (site_of_care) =>
    isSiteOfCareStarted(site_of_care) && !Object.values(siteOfCareRequired(site_of_care)).every(filled);

export const siteOfCareFormatErrors = (site_of_care) => {
    const errors = [];
    if (!isValidOrBlank(ZIP_PATTERN, site_of_care?.address?.zip_code)) {
        errors.push("Site of Care: please enter a valid 5-digit ZIP code.");
    }
    if (!isValidOrBlank(PHONE_PATTERN, site_of_care?.phone_number)) {
        errors.push("Site of Care: please enter a valid 10-digit phone number.");
    }
    if (!isValidOrBlank(NPI_PATTERN, site_of_care?.npi)) {
        errors.push("Site of Care: NPI must be exactly 10 digits.");
    }
    return errors;
};

export const hasInvalidSiteOfCareFormats = (site_of_care) => siteOfCareFormatErrors(site_of_care).length > 0;

